module.exports = __webpack_public_path__ + "static/media/body.3f068516.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/customerexpert/landingpage/body.jpg
// module id = 1615
// module chunks = 0